export const httpurl = "http://116.204.3.174:9898/qizhixiang"
// export const httpurl = "http://192.168.10.3:8080/jeecg-boot/"

//引入axios和qs插件
import axios from "axios";
import qs from "qs";
import { getSign,getTimestamp } from './signMd5Utils'
//创建一个类并导出
export const Server = new (class {
    constructor() {
        //请求接口路径
        // this.loginApi = "/api/user/getuserinfo"; //根据dapp 地址，返回对应的中心化用户信息
        // this.gonggaoList = '/jeecg-boot/wz/wzTzgg/listwz';//公告列表
        // this.newList = '/jeecg-boot/wz/wzNews/listwz';//新闻列表
        // this.gongaoDetail = '/jeecg-boot/wz/wzTzgg/liulan';//公告详情
        // this.newDetail = '/jeecg-boot/wz/wzNews/liulan';//新闻详情
        // this.rezhengList = '/jeecg-boot/ymtb/fwZcxz/list/web';//人才政策的列表
        // this.rezhengDetail = '/jeecg-boot/ymtb/fwZcxz/queryById';//人才政策的详情

        // this.releaseList = "/release/releaseManage/fastList"; // 贸促动态列表
        // this.viewCount = "/release/releaseManage/pageView"; // 带浏览量的查看
        // this.infosList = "/sys/dict/getDictItems/release_type";

        // this.searchInfo = '/release/releaseManage/vagueList'; // 首页搜所结果

        // this.searchArticle = '/zyq/article/pcQueryArticle';  //搜索文章
        // this.searchPicture = '/carousel/carousel/pcQueryCarousel';  // 搜索图片

        this.searchLegislationUrl = '/metering/meteringLaw/check';  //获取计量法律法规

        this.getJiliangnengliList = '/metering/meteringAbility/check'; // 获取计量能力（资质证书、产业计量中心）

        this.getJiliangServerListUrl = '/metering/meteringServiceplan/check'; // 获取计量服务（服务方案）

        this.getCheckServerListUrl = '/inspect/inspectServiceplan/check'; // 获取检测服务（服务方案）

        this.getJiliangServerInfoDetailUrl =  '/metering/meteringServiceplan/checkById'; // 获取计量服务详情（服务方案）

        this.getCheckServerInfoDetailUrl =  '/inspect/inspectServiceplan/checkById'; // 获取检测服务详情（服务方案）

        this.getJianceList = '/inspect/inspectAbility/check'; // 获取检验检测服务数据（检测能力、检验服务方案）   

        this.biaozhunhuaLegislation = '/standard/standardLaw/check'; // 获取标准化法律法规

        this.getShareShiyanshiList = "/laboratory/sharedLaboratory/check"; // 获取共享实验室数据

        this.getRenzhengjianyanLegislation = "/authentication/authenticationLaw/check"; // 获取认证检验检测政策法规

        this.talentsList = '/talenttraining/talenttrainingExpert/check'; // 获取人才培训库数据

        this.getImgService = '/marketsupervision/marketsupervisionService/check'; // 获取60项服务数据

        this.qualityLegislation = '/quality/qualityLaw/check'; // 获取质量政策法规数据

        this.qualityBrand = '/quality/qualityBrand/check'; // 获取质量品牌数据

        this.brandBuild = '/brand/brandEstablish/check'; // 获取品牌建设数据

        this.lzcjfwTitle = '/lzcjfw/lzcjfwTitle/titlelist'; // 获取品牌建设数据

        this.lzcjfwContent1 = '/lzcjfw/lzcjfwContent/titletypelist'; // 获取品牌建设数据
        this.lzcjfwContent2 = '/lzcjfw/lzcjfwContent/wzlist'; // 获取品牌建设数据

        this.lzcjfwContentInfo = '/lzcjfw/lzcjfwContent/queryById'; // 获取品牌建设数据

        this.chujuMainInfo = '/lzcjfw/lzcjfwContent/getlzcjsy'; // 获取品牌建设数据

        this.SubLeftData = '/lzcjfw/lzcjfwTitle/queryLzcjfwTitleFByMainName'//二级类获取标题

        this.SubLeftDataInfo = '/lzcjfw/lzcjfwContent/gettype'//二级类小标题获取内容

        this.mainChujuItem = '/lzcjfw/lzcjfwContent/getlzcjxw'//首页获取小标题内容

        this.serverOrganizationList = '/fwjg/fwjg/fwjgWeb'//服务机构列表查询
        this.getDictStr = '/sys/dict/getDictItems/'//获取字典

        this.NQIQYInfo = '/nqi/nqizhandian/queryById'//获取nqi企业的详情
        this.NQIQYList = '/nqi/nqizhandian/nqizdWeb'//获取nqi企业

        //sspt   1 不锈钢  2陶瓷  3家具
        this.industryStandard = '/nqi/nqibiaozhun/nqibzWeb'//行业标准
        this.industryPolicy = '/nqi/nqizhengce/nqizcWeb'//行业政策
        this.IndustryBenchmark = '/nqi/nqichanyebiaogan/nqicybgWeb'//产业标杆

        this.platformService = '/nqi/nqifuwu/nqifuwuWeb'//平台服务

    }

    // //公告获取
    // wzTzggList(params){
    // 	return axios.get(httpurl + this.gonggaoList,  {params: params}).then((res) => res.data)
    // }
    // 贸促动态
    infoList(params) {
        let param = {
            ...params,
            column: 'releaseTime',
            order: 'desc'
        }
        return axios
            .get(httpurl + this.releaseList, { params: param })
            .then((res) => res.data);
    }

    searchLegislation(params) {
        return axios.get(httpurl + this.searchLegislationUrl, { params: params }).then((res) => res.data)
    }

    getJiliangServerList(params) {
        return axios.get(httpurl + this.getJiliangServerListUrl, { params: params }).then((res) => res.data)
    }

    getlzcjfwTitle(params) {
        return axios.get(httpurl + this.lzcjfwTitle, { params: params }).then((res) => res.data)
    }

    getlzcjfwContent1(params) {
        return axios.get(httpurl + this.lzcjfwContent1, { params: params }).then((res) => res.data)
    }

    getlzcjfwContent2(params) {
        return axios.get(httpurl + this.lzcjfwContent2, { params: params }).then((res) => res.data)
    }

    getMainChujuItem(params) {
        return axios.get(httpurl + this.mainChujuItem, { params: params }).then((res) => res.data)
    }

    getSubLeftData(params) {
        return axios.get(httpurl + this.SubLeftData, { params: params }).then((res) => res.data)
    }

    getSubLeftDataInfo(params) {
        return axios.get(httpurl + this.SubLeftDataInfo, { params: params }).then((res) => res.data)
    }

    getlzcjfwContentInfo(params) {
        return axios.get(httpurl + this.lzcjfwContentInfo, { params: params }).then((res) => res.data)
    }

    getChujuMainInfo(params) {
        return axios.get(httpurl + this.chujuMainInfo, { params: params }).then((res) => res.data)
    }

    getJiliangServerInfoDetail(params) {
        return axios.get(httpurl + this.getJiliangServerInfoDetailUrl, {params: params}).then((res) => res.data)
    }

    getCheckServerList(params) {
        return axios.get(httpurl + this.getCheckServerListUrl, { params: params }).then((res) => res.data)
    }

    getCheckServerInfoDetail(params) {
        return axios.get(httpurl + this.getCheckServerInfoDetailUrl, {params: params}).then((res) => res.data)
    }

    getJiliangnengliInfo(params) {
        return axios.get(httpurl + this.getJiliangnengliList, {params: params}).then((res) => res.data)
    }

    getJianyanjianceInfo(params) {
        return axios.get(httpurl + this.getJianceList, {params: params}).then((res) => res.data)
    }

    getSharelaboratoryInfo(params) {
        return axios.get(httpurl + this.getShareShiyanshiList, {params: params}).then((res) => res.data)
    }
    getRenzhengjianyanLegislationInfo(params) {
        return axios.get(httpurl + this.getRenzhengjianyanLegislation, {params: params}).then(res => res.data)
    }
    getTalentsTrainInfo(params) {
        return axios.get(httpurl + this.talentsList, {params: params}).then(res => res.data)
    }

    getBiaozhunhuaLegislation(params) {
        return axios.get(httpurl + this.biaozhunhuaLegislation, {params: params}).then(res => res.data)
    }

    getImgServiceInfo(params) {
        return axios.get(httpurl + this.getImgService, {params: params}).then(res => res.data)
    }

    getQualityLegislationInfo(params) {
        return axios.get(httpurl + this.qualityLegislation, {params: params}).then(res => res.data)
    }
    
    getQualityBrandInfo(params) {
        return axios.get(httpurl + this.qualityBrand, {params: params}).then(res => res.data)
    }

    getBrandBuildInfo(params) {
        return axios.get(httpurl + this.brandBuild, {params: params}).then(res => res.data)
    }

    searchResult(params) {
        return axios.get(httpurl + this.searchInfo, {params: params}).then((res) => res.data)
    }

    // 带浏览量的列表
    viewCountList(params) {
        return axios.get(httpurl + this.viewCount, {params: params}).then((res) => res.data)
    }
    tabList(params) {
        return axios
            .get(httpurl + this.infosList, { params: params })
            .then((res) => res.data);
    }
    // // 贸促动态详情
    // mcdtDetail(params) {
    //     return axios.get(httpurl + this.maocudongtaiDetail, {params: params}).then((res) => res.data)
    // }
    // // 会员之家
    // hyzjList(params) {
    //     return axios.get(httpurl + this.huiyuanzhijiaList, {params: params}).then((res) => res.data)
    // }
    // // 会员之家详情
    // hyzjDetail(params) {
    //     return axios.get(httpurl + this.huiyuanzhijiaDetail, {params: params}).then((res) => res.data)
    // }

    articleList(params) {
        return axios.get(httpurl + this.searchArticle, {params: params}).then((res) => res.data)
    }
    pictureList(params) {
        return axios.get(httpurl + this.searchPicture, {params: params}).then((res) => res.data)
    }
    getServerOrganizationList(params) {
        return axios.get(httpurl + this.serverOrganizationList, {params: params}).then((res) => res.data)
    }
    getDict(params) {
        let sign = getSign(httpurl + this.getDictStr + params, '');
        // {
        //     params: params, // axios 自动拼接参数，自动编码，不会出错
        //     headers: {}
        // }
        return axios.get(httpurl + this.getDictStr + params, {headers:{'X-Sign':sign,'X-TIMESTAMP':getTimestamp()}}).then((res) => res.data)
    }
    getNQIQYInfo(params) {
        return axios.get(httpurl + this.NQIQYInfo, {params: params}).then((res) => res.data)
    }
    getNQIQYList(params) {
        return axios.get(httpurl + this.NQIQYList, {params: params}).then((res) => res.data)
    }
    getIndustryStandardList(params) {
        return axios.get(httpurl + this.industryStandard, {params: params}).then((res) => res.data)
    }
    getIndustryPolicyList(params) {
        return axios.get(httpurl + this.industryPolicy, {params: params}).then((res) => res.data)
    }
    getIndustryBenchmarkList(params) {
        return axios.get(httpurl + this.IndustryBenchmark, {params: params}).then((res) => res.data)
    }
    getPlatformServiceInfo(params) {
        return axios.get(httpurl + this.platformService, {params: params}).then((res) => res.data)
    }
    
})();
